import RetainedData from './retained-data'

class Telemetry {
  // Overload signatures
  static async trackEvent(event: 'pageview'): Promise<void>

  static async trackEvent(
    event: 'download',
    meta: { hostApp: string }
  ): Promise<void>

  static async trackEvent(event: 'purchase.click-sign-up'): Promise<void>
  static async trackEvent(event: 'purchase.complete'): Promise<void>

  static async trackEvent(
    event: 'press-kit.right-click-site-logo'
  ): Promise<void>
  static async trackEvent(
    event: 'press-kit.download-promo',
    meta: { alt: string }
  ): Promise<void>
  static async trackEvent(
    event: 'press-kit.download-screenshot',
    meta: { hostApp: string }
  ): Promise<void>
  static async trackEvent(
    event: 'press-kit.get-logo',
    meta: { method: 'save-svg' | 'copy-svg' | 'save-png' }
  ): Promise<void>

  static async trackEvent(event: 'demo.ready'): Promise<void>
  static async trackEvent(event: 'demo.interact'): Promise<void>
  static async trackEvent(
    event: 'demo.click-close-button',
    meta: {
      quantity: number
    }
  ): Promise<void>
  static async trackEvent(event: 'demo.break-demo'): Promise<void>
  static async trackEvent(event: 'demo.first-hidden-signup'): Promise<void>
  static async trackEvent(event: 'demo.last-hidden-signup'): Promise<void>
  static async trackEvent(
    event: 'support.submit-form',
    meta: { topic: string }
  ): Promise<void>
  static async trackEvent(
    event: 'video.youtube',
    meta: { youtubeID: string }
  ): Promise<void>

  // Implementation
  static async trackEvent(
    type:
      | 'pageview'
      | 'download'
      | 'purchase.click-sign-up'
      | 'purchase.complete'
      | 'press-kit.right-click-site-logo'
      | 'press-kit.download-promo'
      | 'press-kit.download-screenshot'
      | 'press-kit.get-logo'
      | 'demo.ready'
      | 'demo.interact'
      | 'demo.click-close-button'
      | 'demo.break-demo'
      | 'demo.first-hidden-signup'
      | 'demo.last-hidden-signup'
      | 'support.submit-form'
      | 'video.youtube',

    meta?: {}
  ) {
    const appId = '5B242C8B-B705-4835-B056-F3252A761553'
    const api = 'https://nom.telemetrydeck.com/v2/w/'
    const { language: locale } = navigator
    const { location } = globalThis

    let body: any = {
      appID: appId,
      url: location.href,
      referrer: document.referrer,
      locale,
      type,
      ...meta,
    }

    if (!/^guideguide\.me$/.test(location.hostname)) {
      body.isTestMode = true
    }

    const storedData = RetainedData.get()
    if (storedData) body = { ...body, ...storedData }

    fetch(api, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
  }
}

export default Telemetry
